import { tokens } from '@elka/theme';
import { DEAL_QUOTING_STATUS_LABELS } from '@elka/types';
import type { DealQuotingStatus } from '@elka/types';
import { quotingStepIndex } from '../lib/nextAction';

interface QuotingProgressDotsProps {
  status: DealQuotingStatus;
}

const STEP_LABELS = ['קליטה', 'תמחור', 'הצעה', 'שליחה'];

/**
 * Compact 4-dot quoting-progress indicator used in the deals list. Replaces the
 * stage + quoting-status badge pair with a single glance-friendly row:
 *
 *   ●━●━○━○   תמחור · בחר מחירים
 */
export function QuotingProgressDots({ status }: QuotingProgressDotsProps) {
  const activeIdx = quotingStepIndex(status);
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center">
        {STEP_LABELS.map((_, i) => {
          const done = i < activeIdx;
          const active = i === activeIdx;
          const color = done
            ? tokens.colors.pricing.green
            : active
              ? tokens.colors.pricing.blue
              : '#CBD5E1';
          return (
            <div key={i} className="flex items-center">
              <div
                style={{
                  width: 9,
                  height: 9,
                  borderRadius: 999,
                  background: color,
                  boxShadow: active ? `0 0 0 3px rgba(60,95,168,0.15)` : undefined,
                }}
              />
              {i < STEP_LABELS.length - 1 && (
                <div
                  style={{
                    width: 12,
                    height: 2,
                    background: done ? tokens.colors.pricing.green : '#E2E8F0',
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
      <span
        className="text-[11px] font-bold whitespace-nowrap"
        style={{ color: tokens.colors.pricing.navy }}
      >
        {STEP_LABELS[activeIdx]}
      </span>
      <span
        className="text-[10px] whitespace-nowrap"
        style={{ color: tokens.colors.pricing.textMute }}
      >
        · {DEAL_QUOTING_STATUS_LABELS[status]}
      </span>
    </div>
  );
}
